import { render, staticRenderFns } from "./PassportRegister.vue?vue&type=template&id=69ce03c9&scoped=true&"
import script from "./PassportRegister.vue?vue&type=script&lang=js&"
export * from "./PassportRegister.vue?vue&type=script&lang=js&"
import style0 from "./PassportRegister.vue?vue&type=style&index=0&id=69ce03c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ce03c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})
